import { render, staticRenderFns } from "./ednColor.vue?vue&type=template&id=3c36f2c3&"
import script from "./ednColor.vue?vue&type=script&lang=js&"
export * from "./ednColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports